"use client"
import React, { useEffect, useState } from "react"
import clsx from "clsx"
import { twMerge } from "tailwind-merge"
import { ChevronLeft, ChevronRight } from "lucide-react"
import Link from "next/link"
import { Locale } from "../../../i18n-config"
import Lucide from "@/base-components/Lucide"
import menuData from "../Header/menuData"
import { useDictionary } from "@/libs/DictionaryProvider"
import Disclosure from "@/base-components/Disclosure"
import ClosedSideBar from "../ClosedSideBar"
import { usePathname } from "next/navigation"

const Sidebar = ({ lang }: { lang: Locale }) => {
  const [top, setTop] = useState(false)
  const [collasped, setCollasped] = useState(true)
  const { navigation } = useDictionary()
  const pathUrl = usePathname()

  // Sticky menu
  const followStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setTop(true)
    } else {
      setTop(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", followStickyNavbar)
  }, [])

  return (
    <nav
      className={twMerge(
        clsx(
          "hidden lg:flex !min-w-[18%] sticky m-0 mt-[40px] top-[80px]  !max-h-[calc(90vh)]  left-0   py-3 bg-dark transition-all delay-0 duration-100 z-999 border-r border-white/[0.12]",
          // top && "top-[68px]",
          collasped && "!min-w-[7%] !max-w-[5%]",
        ),
      )}
    >
      {/* <div className="relative w-full h-full"> */}
      <div
        className="absolute flex items-center  justify-center text-white right-[-10px] top-14 w-[20px] h-[20px] bg-gray-500 rounded-2xl z-9999 hover:cursor-pointer hover:bg-gray-800"
        onClick={() => {
          setCollasped(!collasped)
        }}
      >
        {collasped ? <ChevronRight /> : <ChevronLeft />}
      </div>

      {!collasped ? (
        <div className="flex flex-col gap-4   items-left pt-5 w-full px-4 !overflow-y-scroll  no-scrollbar ">
          {menuData.map((menuItem, key) => (
            <div key={key}>
              {!menuItem.submenu ? (
                <Link
                  prefetch={menuItem.path === "tools/trade" ? false : true}
                  href={`/${lang}/${menuItem.path}`}
                  data-onboarding={
                    menuItem.path.includes("tools/tracker")
                      ? "tracker-nav"
                      : undefined
                  }
                  className="w-full"
                  key={key}
                >
                  <div
                    className={`flex w-full hover:text-white font-semibold p-2 cursor-pointer rounded-lg hover:bg-white/5 ${
                      pathUrl.includes(menuItem.path)
                        ? "nav-gradient-closed text-white"
                        : "text-white/80"
                    }`}
                  >
                    <span>
                      <Lucide icon={menuItem.icon} />
                    </span>
                    <span
                      className={clsx(
                        "block transition-all delay-100",
                        collasped && "hidden",
                      )}
                    >
                      {navigation[menuItem.title]}
                    </span>
                  </div>
                </Link>
              ) : (
                <Disclosure className="mb-2">
                  <Disclosure.Button
                    data-onboarding={
                      menuItem.path.includes("tools/tracker")
                        ? "tracker-nav"
                        : undefined
                    }
                    className={`flex w-full hover:text-white  font-semibold my-0.5 p-2 cursor-pointer rounded-lg hover:bg-white/5 ${
                      pathUrl.includes(menuItem.path)
                        ? "nav-gradient-closed text-white"
                        : "text-white/80"
                    }`}
                    collasped={collasped}
                  >
                    <span>
                      <Lucide icon={menuItem.icon} />
                    </span>
                    <span
                      className={clsx(
                        "block transition-all delay-100",
                        collasped && "hidden",
                      )}
                    >
                      {navigation[menuItem.title].title}
                    </span>
                  </Disclosure.Button>
                  <Disclosure.Panel className="leading-relaxed pl-5">
                    {menuItem.submenu.map((item, key) => (
                      <Link
                        href={`/${lang}/${item.path}`}
                        className="w-full "
                        key={key}
                      >
                        <div
                          className={`flex w-full hover:text-white text-white/80 font-semibold p-2 cursor-pointer rounded-lg hover:bg-white/5 `}
                        >
                          <span>
                            <Lucide
                              icon={item.icon ? item.icon : "CircleHelp"}
                            />
                          </span>
                          <span
                            className={clsx(
                              "block transition-all delay-100",
                              collasped && "hidden",
                            )}
                          >
                            {navigation[menuItem.title][item.title]}
                          </span>
                        </div>
                      </Link>
                    ))}
                  </Disclosure.Panel>
                </Disclosure>
              )}
            </div>
          ))}
        </div>
      ) : (
        <ClosedSideBar lang={lang} />
      )}
    </nav>
  )
}

export default Sidebar
